import { render } from "./connectionComponent.vue?vue&type=template&id=2d1fb679&scoped=true&ts=true"
import script from "./connectionComponent.vue?vue&type=script&lang=ts"
export * from "./connectionComponent.vue?vue&type=script&lang=ts"

import "./connectionComponent.vue?vue&type=style&index=0&id=2d1fb679&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1fb679"]])

export default __exports__